import { Fab, CardActionArea } from '@mui/material';
import { blue } from '@mui/material/colors';
import React, { useEffect, useState } from 'react';
import ConfirmationDialog from '../dialogs/confirmation.dialog';
import pdfImg from "../../assets/img/pdf.png";

document.addEventListener("dragover", (event) => {
    event.preventDefault();
});

export interface FileUploaderProps {
    id: string,
    onChange: (id: string, data: any, text: string, size: number) => boolean,
    onClickImage?: (id: string) => void,
    clearInternalWhenClick?: boolean,
    photo?: string,
    handleDrag?: (props: FileUploaderProps) => void,
    handleDrop?: (props: FileUploaderProps) => void,
    disabled?: boolean
}

export default function FileUploader(props: FileUploaderProps) {
    const [photo, setPhoto] = useState<string>();

    const inputId = `input-${props.id}`;

    const [dialogRemoveVisible, setDialogRemoveVisible] = useState(false);

    useEffect(() => {
        if (props && props.photo) {
            const extension = props.photo.split(':')[1].split('/')[1].split(';')[0].toLowerCase();
            if (extension === 'pdf')
                setPhoto(pdfImg);
            else
                setPhoto(props.photo);
        }
        else {
            setPhoto(props.photo);
        }

    }, [props]);

    async function onChange(e: any) {
        var file = e.target.files[0];

        const size = file.size / (1024 * 1024);

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onloadend = async function (_: any) {
            if (props.onChange) {
                const changed = props.onChange(props.id, reader.result, file.name, size);
                if (!changed) {
                    setPhoto(undefined);
                    return;
                }
            }

            const extension = file.name.split('.').pop().toLowerCase();
            let content = reader.result as string;

            if (extension === 'pdf') {
                content = pdfImg
            }

            setPhoto(content);
        };
    }

    function onDrop(_: any) {
        props.handleDrop?.(props);
    }

    function onDragEnd(e: any) {
        e.preventDefault();
        e.stopPropagation();
    }

    function onDragFrom(e: any) {
        e.stopPropagation();

        if (props.handleDrag)
            props.handleDrag(props);
    }

    const onRemove = () => setDialogRemoveVisible(true);

    const ok = () => {
        props.onClickImage?.(props.id);

        setDialogRemoveVisible(false);

        if (!!props.clearInternalWhenClick)
            setPhoto(undefined);
    }

    return <>
        {!photo && <>
            <input
                accept="image/*, .pdf"
                style={{ display: 'none' }}
                id={inputId}
                type="file"
                onChange={onChange} />
            <label
                htmlFor={inputId}
                onDrop={onDrop}
            >
                <Fab component="span" sx={{
                    color: blue[900],
                    margin: 10,
                }}
                    disabled={props.disabled}
                >
                    {'+'}
                </Fab>
            </label>
        </>}

        {photo && <div
            key={crypto.randomUUID()}
            style={{
                maxWidth: '300px',
                maxHeight: '300px'
            }}>
            <CardActionArea
                onClick={onRemove}
                onDragEnd={onDragEnd}
                onDragStart={onDragFrom}
            >
                <img src={photo} alt={''} style={{
                    width: '100%',
                    maxHeight: '300px',
                }} />
            </CardActionArea>
        </div>}

        {dialogRemoveVisible && <ConfirmationDialog
            title={'Deseja realmente apagar a imagem atual?'}
            text={'Fique tranquilo, se você não clicar em "Salvar", a imagem não será substituida.'}
            onConfirm={ok}
            onClose={() => setDialogRemoveVisible(false)}
        />}
    </>
}